import { IDeleteObraArquivoUseCase } from "../../../presentation/useCases/delete/delete_obra_arquivo_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraArquivoUseCase
 */

export class DeleteObraArquivoUseCase implements IDeleteObraArquivoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteObraArquivo(
    idObraArquivo: number,
  ): Promise<void> {
    await this.repository.deleteObraArquivo(idObraArquivo);
  }
}
